import i18n from '@plugins/i18n'
import '@shared/components'
import Logger, { LoggerInterface } from '@shared/logger'
import '@shared/plugins'
import Vue, { VueConstructor } from 'vue'
import feedback from '../mixins/feedback'
import navigation from '../mixins/navigation'

export default class Application {
  protected vm: Vue
  private logger: LoggerInterface

  constructor(modules: any = []) {
    this.initLogger()
    this.bindListeners()
    this.requireIcons()
    this.vhFix()

    if (!Array.isArray(modules)) {
      modules = [modules]
    }

    modules.push(navigation)
    modules.push(feedback)

    this.initVue(modules)
  }

  private initVue(modules: VueConstructor[]) {
    this.vm = new Vue({
      name: 'App',
      i18n,
      mixins: modules,
      data: {},
    })

    this.vm.$mount('#admin-app')
  }

  private initLogger() {
    this.logger = new Logger()

    Vue.config.errorHandler = (err, vm, info) => {
      this.logger.addErrorRecord(err)
      if (DEBUG) {
        throw err
      }
    }
  }

  private bindListeners() {
    window.addEventListener('orientationchange', this.vhFix)
    window.addEventListener('resize', this.vhFix)
  }

  private requireIcons() {
    const div = document.createElement('div')
    const body = document.body
    const cssString =
      'border: 0; clip: rect(0 0 0 0); height: 0; overflow: hidden; padding: 0; position: absolute; width: 0;'

    div.style.cssText = cssString
    div.innerHTML = require('!!html-loader!../../img/icons.svg')
    body.insertBefore(div, body.childNodes[0])
  }

  private vhFix() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
}
